import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Routes from './route';
import 'styles/global.less';
import 'styles/general.less';
import history from './history';

import store from './store/index'
import AjaxService from "./ajaxService";
import MainPage from 'pages/SinglePage/main-page';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

export const dataService = new AjaxService(store,history);

function App() {
  ReactGA.initialize('UA-63707820-1');
  ReactPixel.init('470016443928963');

  const routeComponents = Routes.map(({ path, component }, index) => {
    return <Route history={history} exact path={path} key={index} component={component} />;
  });
  return <Router history={history}  basename="/">  <Switch>{routeComponents}<Route path="/" component={MainPage} /></Switch></Router>;
}

export default App;
